import {otsBaseApi} from "../../ots-api";
import {RouteGroup} from "../../../model/route-group";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["RouteGroups"]});

export const routeGroupApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllRouteGroups: builder.query<RouteGroup[], string | undefined>({
      query: (regionId) => ({
        url: `/route-groups/all`,
        method: "GET",
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "RouteGroups", id} as const)),
            {type: "RouteGroups", id: "LIST"}
          ];
        } else {
          return [{type: "RouteGroups", id: "LIST"}];
        }
      }
    }),
    getRouteGroup: builder.query<RouteGroup, string>({
      query: (id) => ({
        url: `/route-groups/${id}`,
        method: "GET"
      }),
      providesTags: (result, error, id) => [{type: "RouteGroups", id}]
    }),
    createRouteGroup: builder.mutation<RouteGroup, Partial<RouteGroup>>({
      query: (mapping) => ({
        url: "/route-groups",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "RouteGroups", id: "LIST"}]
    }),
    updateRouteGroup: builder.mutation<RouteGroup, Partial<RouteGroup>>({
      query: (mapping) => ({
        url: "/route-groups",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: "RouteGroups", id}]
    }),
    deleteRouteGroup: builder.mutation<void, Partial<RouteGroup>>({
      query: (mapping) => ({
        url: "/route-groups",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "RouteGroups", id}]
    })
  })
});

export const {
  useGetAllRouteGroupsQuery,
  useGetRouteGroupQuery,
  useCreateRouteGroupMutation,
  useUpdateRouteGroupMutation,
  useDeleteRouteGroupMutation,
} = routeGroupApi;
